import type { JSX } from "react";
import { cva, type VariantProps } from "class-variance-authority";

const containerVariants = cva(
  "mx-auto w-full",
  {
    variants: {
      size: {
        sm: "max-w-2xl",
        md: "max-w-4xl",
        lg: "max-w-7xl",
        xl: "max-w-screen-xl",
        full: "max-w-full",
      },
      padding: {
        none: "",
        sm: "px-4",
        md: "px-6 lg:px-8",
        lg: "px-8 lg:px-12",
      },
    },
    defaultVariants: {
      size: "lg",
      padding: "md",
    },
  }
);

interface ContainerProps extends VariantProps<typeof containerVariants> {
  children: React.ReactNode;
  className?: string;
  as?: "div" | "section" | "article" | "main" | "header" | "footer";
}

export function Container({
  children,
  size,
  padding,
  className,
  as: Component = "div",
}: ContainerProps): JSX.Element {
  return (
    <Component className={containerVariants({ size, padding, className })}>
      {children}
    </Component>
  );
}
